import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-edit-drug",
    templateUrl: "./edit-drug.component.html",
    standalone: false
})
export class EditDrugComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
